import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralStatusIA = function BrandReferralStatusIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_STATUS_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_STATUS_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_STATUS_TITLE = function BRAND_REFERRALS_STATUS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "MBTd1t",
    defaultMessage: [{
      "type": 0,
      "value": "Como consultar o estado dos convites de marcas"
    }]
  });
};
var BRAND_REFERRALS_STATUS_DESCRIPTION = function BRAND_REFERRALS_STATUS_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "HhHXze",
    defaultMessage: [{
      "type": 0,
      "value": "Aceda a \"Convidar marcas\" em \"Conta\" e selecione o separador \"Marcas convidadas\" para verificar o estado da candidatura de uma determinada marca. Apenas podemos partilhar detalhes adicionais sobre a candidatura de uma marca diretamente com a própria marca."
    }]
  });
};